<div class="tw-flex tw-flex-col tw-items-start tw-gap-4 tw-w-full tw-min-h-[28rem]">
  <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-4 tw-w-full">
    <h3 class="tw-font-inter tw-font-semibold tw-text-base tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
      {{ 'v2.orgSettings.billing.lastTransactions' | translate }}
      @if (!isLoading() && transactions().length) {
      <span class="tw-font-normal tw-text-gray-500 dark:tw-text-gray-400">({{ transactions().length }})</span>
      }
    </h3>
  </div>

  @if (isLoading()) {
  <div
    class="tw-flex tw-w-full tw-min-h-[24rem] tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700"
  >
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        width: '100%',
        height: '64px',
        'border-radius': '0',
        backgroundColor: getSkeletonTheme().backgroundColor,
        color: getSkeletonTheme().color
      }"
      animation="pulse"
    ></ngx-skeleton-loader>
    @for (row of [1, 2, 3, 4, 5]; track row) {
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        width: '100%',
        height: '64px',
        'border-radius': '0',
        marginTop: '0',
        backgroundColor: getSkeletonTheme().backgroundColor,
        color: getSkeletonTheme().color
      }"
      animation="pulse"
    ></ngx-skeleton-loader>
    }
  </div>
  } @else if (isEmpty()) {
  <div class="tw-flex tw-min-h-[24rem] tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-py-10 tw-text-center">
    <img [src]="emptyStateImage" alt="" class="tw-w-full tw-max-w-[307px] tw-h-auto" />
    <p class="tw-font-inter tw-font-semibold tw-text-base tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
      {{ 'v2.orgSettings.billing.noTransactionsTitle' | translate }}
    </p>
    <p class="tw-font-inter tw-font-normal tw-text-sm tw-leading-5 tw-text-gray-500 dark:tw-text-gray-400 tw-max-w-md">
      {{ 'v2.orgSettings.billing.noTransactionsDescription' | translate }}
    </p>
  </div>
  } @else {
  <div
    #tableScrollContainer
    class="tw-w-full tw-min-h-[24rem] tw-max-h-96 tw-overflow-x-auto tw-overflow-y-auto tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 [scrollbar-width:thin] [-ms-overflow-style:auto] [&::-webkit-scrollbar]:tw-h-2 [&::-webkit-scrollbar]:tw-w-2 [&::-webkit-scrollbar-thumb]:tw-rounded-full [&::-webkit-scrollbar-thumb]:tw-bg-gray-300"
  >
      <div
        class="tw-grid tw-max-h-16 tw-w-fit lg:tw-w-full tw-grid-cols-[minmax(180px,1fr)_120px_120px_140px] tw-gap-0 tw-sticky tw-top-0 tw-border-b tw-border-gray-200 dark:tw-border-gray-700 tw-bg-gray-50 dark:tw-bg-gray-800/95"
      >
        <span class="tw-px-4 tw-py-3 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.orgSettings.billing.descriptionColumn' | translate }}
        </span>
        <span class="tw-px-4 tw-py-3 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.orgSettings.billing.amountColumn' | translate }}
        </span>
        <span class="tw-px-4 tw-py-3 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.orgSettings.billing.balanceColumn' | translate }}
        </span>
        <span class="tw-px-4 tw-py-3 tw-font-inter tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.orgSettings.billing.dateColumn' | translate }}
        </span>
      </div>

      @for (transaction of transactions(); track trackByTransactionId($index, transaction); let i = $index) {
      <div
        class="tw-grid tw-content-center tw-items-center tw-max-h-16 tw-w-fit lg:tw-w-full tw-grid-cols-[minmax(180px,1fr)_120px_120px_140px] tw-gap-0 tw-border-b tw-border-gray-100 dark:tw-border-gray-700 last:tw-border-b-0"
        [ngClass]="i % 2 === 1 ? 'tw-bg-gray-50/70 dark:tw-bg-gray-800/30' : 'tw-bg-white dark:tw-bg-gray-800'"
      >
        <div
          class="tw-px-4 tw-py-4 tw-min-w-0 tw-max-w-full tw-overflow-x-auto "
        >
          <span class="tw-font-inter tw-text-sm tw-text-gray-900 tw-font-semibold dark:tw-text-gray-300 tw-whitespace-nowrap">
            {{ transaction.description }}
          </span>
        </div>
        <span class="tw-px-4 tw-flex tw-py-4 tw-font-inter tw-text-sm tw-font-semibold tw-whitespace-nowrap">
          @if (transaction.credit > 0) {
          <span class="tw-text-green-600">+ {{ transaction.credit | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
          } @else if (transaction.debit > 0) {
          <span class="tw-text-red-600">- {{ transaction.debit | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
          } @else {
          <span class="tw-text-gray-600 dark:tw-text-gray-300">-</span>
          }
        </span>
        <span class="tw-px-4 tw-flex tw-py-4 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300 tw-whitespace-nowrap">
          {{ transaction.balance | currency : 'USD' : 'symbol' : '1.2-2' }}
        </span>
        <span class="tw-px-4 tw-py-4 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-600 dark:tw-text-gray-300 ">
          @if (getTransactionDateParts(transaction.date); as dateParts) { @if (dateParts.timePart) {
          <span class="tw-block">{{ dateParts.datePart }},</span>
          <span class="tw-block">{{ dateParts.timePart }}</span>
          } @else {
          {{ dateParts.datePart }}
          } }
        </span>
      </div>
      } @if (isLoadingMore()) {
      <div class="tw-px-4 tw-py-4 tw-text-center">
        <p class="tw-font-inter tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
          {{ 'v2.orgSettings.billing.loadingMoreTransactions' | translate }}
        </p>
      </div>
      }

      <div #loadMoreTrigger class="tw-h-2 tw-w-full" aria-hidden="true"></div>
    </div>
  }
</div>
